import { http } from './common';
import {
    METHOD_PUT,
    METHOD_POST,
    SERVER_URL,
    METHOD_GET,
    METHOD_DELETE,
} from '../constants/api';
import {
    headersAuthSendReceiveJson, headersAuthReceiveJson,
    headersAuthReceiveOctet,
    headersAuth
} from '../headers';
import { apiHandleOctetResponseWithFileName, apiHandleResponse } from '../../util/api';

const getMonthlyLimits = async (clientId) =>
    http.get(`/api/v1/credit-accounts/usage/${clientId}`);

const editMonthlyLimits = async (payload) => 
    http.put(`/api/v1/credit-account/limit`, payload);

const creditUsageReport = (startDate, endDate) => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return fetch(`${SERVER_URL}/api/v1/credit/report/usage/${startDate}/${endDate}?timezone=${timeZone}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const downloadReport = (startDate, endDate) => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return fetch(`${SERVER_URL}/api/v1/credit/export/usage/${startDate}/${endDate}?timezone=${timeZone}`, {
        method: METHOD_POST,
        headers: headersAuthReceiveOctet(),
    }).then(apiHandleOctetResponseWithFileName);
};

const aiCreditUsageReport = (startDate, endDate) => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return fetch(`${SERVER_URL}/api/v1/credit/report/usage/ai/${startDate}/${endDate}?timezone=${timeZone}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const aiDownloadReport = (startDate, endDate) => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return fetch(`${SERVER_URL}/api/v1/credit/export/usage/ai/${startDate}/${endDate}?timezone=${timeZone}`, {
        method: METHOD_POST,
        headers: headersAuthReceiveOctet(),
    }).then(apiHandleOctetResponseWithFileName);
};

const systemCreditUsageReport = (startDate, endDate) => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return fetch(`${SERVER_URL}/api/v1/credit/report/usage/system/${startDate}/${endDate}?timezone=${timeZone}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const creditAccountUsageReport = (startDate, endDate) => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return fetch(`${SERVER_URL}/api/v1/credit/report/account/${startDate}/${endDate}?timezone=${timeZone}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const systemDownloadReport = (startDate, endDate) => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return fetch(`${SERVER_URL}/api/v1/credit/export/usage/system/${startDate}/${endDate}?timezone=${timeZone}`, {
        method: METHOD_POST,
        headers: headersAuthReceiveOctet(),
    }).then(apiHandleOctetResponseWithFileName);
};

const creditAccountDownloadReport = (startDate, endDate) => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return fetch(`${SERVER_URL}/api/v1/credit/export/account/${startDate}/${endDate}?timezone=${timeZone}`, {
        method: METHOD_POST,
        headers: headersAuthReceiveOctet(),
    }).then(apiHandleOctetResponseWithFileName);
};

export {
    getMonthlyLimits,
    editMonthlyLimits,
    creditUsageReport,
    downloadReport,
    aiCreditUsageReport,
    aiDownloadReport,
    systemCreditUsageReport,
    systemDownloadReport,
    creditAccountUsageReport,
    creditAccountDownloadReport
}